import caseInsuranceTranslations from "./caseInsuranceTranslations";
import personTranslations from "./personTranslations";
import customerTranslations from "./customerTranslations";

const abstractCaseTranslations = {
  reference: {
    label: "Unser Zeichen",
  },
  customer: customerTranslations,
  caseCategory: {
    label: "Anliegen Mandantschaft",
    values: {
      advisory: "Erstberatung",
      enforceClaim: "Forderung durchsetzen (Kläger)",
      defendClaim: "Forderung abwehren (Beklagter)",
    },
  },
  caseCategoryAssessment: {
    label: "Einschätzung des Falls",
    values: {
      confirm: "Anliegen bestätigen",
      reject: "Kein weiteres Vorgehen / rechtliche Grundlage ?",
    },
  },
  caseRejectionCategory: {
    label: "Grund für Einschätzung (Text-Vorlage)",
    values: {
      none: "Keine Vorlage",
      individual: "Vorgehen wie im Telefonat besprochen",
      electricityProvider: "Preiserhöhung Stromversorger",
      opponentNonEu: "Gegenseite Ausland (nicht EU)",
      fraudNoOpponent: "Betrugsfall + Gegenseite unbekannt",
      fraudNoOpponentAlreadyFiled: "Betrugsfall, Anzeige bereits gestellt, aber Gegenseite unbekannt",
      businessToBusinessContract: "Gewerblicher Vertragsabschluss",
      specialistLawyerNeeded: "Fachanwalt notwendig",
      claimEnforcable: "Forderung vollstreckbar/Vollstreckungsbescheid",
      enforceClaimTimeBarred: "Forderung verjährt - Forderung durchsetzen",
      defendClaimTimeBarred: "Forderung verjährt - Forderung abwehren",
      unlikelySuccessful: "Schlechte Erfolgsaussichten",
      fraudLottery: "Betrugsfall Lotto 6/49",
      schufaNoPositiveData: "Schufa - kein Positiveintrag vorhanden",
    },
  },
  assessmentRejectionText: {
    label: "Nachrichtentext zur Einschätzung",
  },
  paymentMethod: {
    label: "Bezahlmethode",
  },
  responsibleLawyer: {
    label: "Anwalt",
  },
  backofficeCase: {
    accountManager: {
      label: "Zuständiger",
    },
  },
  legalExpenseInsurance: {
    label: "Rechtschutzversichert",
    values: {
      true: "Ja",
      false: "Nein",
    },
  },
  powerOfAttorney: {
    label: "Vollmacht erteilt am",
  },
  personalTextMessage: {
    label: "Fragen und Anmerkungen zum Fall",
  },
  caseInsurance: caseInsuranceTranslations,
  petitioner: personTranslations,
  client: personTranslations,
  preventAccounting: {
    label: "Konto/Rechnungen pausieren",
    values: {
      true: "inaktiv",
      false: "aktiv",
    },
  },
  preventAllSystemEmails: {
    label: "Emails und Nachrichten pausieren",
    values: {
      true: "inaktiv",
      false: "aktiv",
    },
  },
  caseDescription: {
    label: "Fallzusammenfassung",
  },
  additionalClient: {
    gender: {
      label: "Anrede weitere Mandantschaft",
      values: {
        male: "Herr",
        female: "Frau",
      },
    },
    givenName: {
      label: "Vorname weitere Mandantschaft",
    },
    familyName: {
      label: "Nachname weitere Mandantschaft",
    },
  },
  preventStatusChangeByCustomer: {
    label: "Statusänderung durch Mandantschaft",
    values: {
      true: "pausiert",
      false: "angeschaltet",
    },
  },
};

export default abstractCaseTranslations;
